<div  style="position:fixed;width:100%;height:100%;left:0;top:0;background:#fff;z-index:99999">
    <div style="width:auto;height:auto;left:45%;top:45%;position:absolute;">
      <img src="assets/Images/ajax-loader.gif" alt="loader" style="width: 100px"> 
    </div>
  </div>
  